export const getCamelCaseString = str =>
  str.replace(/([A-Z])/g, ' $1').replace(/^./, string => {
    return string.toUpperCase();
  });
